/**
 * One name per opened browser page, sent with every store of a screen that
 * the server guards against out-of-date screens (D10). The server
 * remembers which screen stored last, so a screen's own store never makes
 * that same screen "out of date": also the store it sends as the person
 * looks away, whose answer it never hears.
 */
const random = (): string => {
  try {
    return crypto.randomUUID();
  } catch (_e) {
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
};

export const STORE_SCREEN: string = random();
